<template>
  <div>
    <common-manage ref="commonManage"></common-manage>
    <v-row no-gutters>
      <v-breadcrumbs :items="Crums" class="pl-1">
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs>
    </v-row>
    <v-form ref="form" lazy-validation>
      <v-row v-if="user_type_id == 1">
        <v-col cols="4" >
          <v-select :items="Schools" item-text="name" item-value="id" :rules="requiredRules" dense v-model="instructor.school_id" outlined>
            <template slot="label">{{ $t('school.label') }}<span style="color:orange"><b>*</b></span></template>
          </v-select>
        </v-col>
      </v-row>
      <v-card class="my-2">
        <v-subheader class="blue accent-4" style="color:white" dark><b>{{ $t('instructor.tab1-header') }}</b></v-subheader>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="4" class="pb-0">
              <v-text-field :rules="whiteSpaceRules.concat(requiredRules)" outlined dense v-model="instructor.name">
                <template slot="label">{{ $t('name') }}<span style="color:orange"><b>*</b></span></template>
              </v-text-field>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-text-field :rules="emailRules" :error-messages="errors.email" dense outlined v-model="instructor.email">
                <template slot="label">{{ $t('email') }}<span style="color:orange"><b>*</b></span></template>
              </v-text-field>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-text-field label="Contact Number" :rules="phoneRules" dense outlined v-model="instructor.contact_number" prefix="+971">
                <template slot="label">{{ $t('contact-number') }}<span style="color:orange"><b>*</b></span></template>
              </v-text-field>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-select label="Gender" :items="Gender" item-text="name" item-value="id" :rules="requiredRules" dense v-model="instructor.gender" outlined>
                <template slot="label">{{ $t('gender') }}<span style="color:orange"><b>*</b></span></template>
              </v-select>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-select :items="Country" :item-text="$i18n.locale=='en'? 'name_en':'name_ar'" item-value="id" :rules="requiredRules" dense v-model="instructor.country_id" outlined>
                <template slot="label">{{ $t('country') }}<span style="color:orange"><b>*</b></span></template>
              </v-select>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-select :items="Emirates" :item-text="$i18n.locale=='en'? 'name_en':'name_ar'" item-value="id" :rules="requiredRules" dense v-model="instructor.emirate_id" @keyup="toUpperCase($event)" outlined>
                <template slot="label">{{ $t('emirates') }}<span style="color:orange"><b>*</b></span></template>
              </v-select>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-text-field label="Address Line 1" :rules="requiredRules" dense v-model="instructor.address_line_1" outlined>
                <template slot="label">{{ $t('address1') }}<span style="color:orange"><b>*</b></span></template>
              </v-text-field>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-text-field :label="$t('address2')" dense v-model="instructor.address_line_2" outlined></v-text-field>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-text-field :label="$t('po-box')" dense v-model="instructor.po_box" outlined></v-text-field>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-select :items="Country" :item-text="$i18n.locale=='en'? 'name_en':'name_ar'" item-value="id" :rules="requiredRules" dense v-model="instructor.nationality_id" outlined>
                <template slot="label">{{ $t('nationality') }}<span style="color:orange"><b>*</b></span></template>
              </v-select>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-text-field dense v-model="instructor.eid" outlined :rules="requiredRules" @keyup="toUpperCase($event)">
                <template slot="label">{{ $t('emirates-id') }}<span style="color:orange"><b>*</b></span></template>
              </v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="my-2">
        <v-subheader class="blue accent-4" style="color:white" dark><b>{{ $t('instructor.tab2-header') }}</b></v-subheader>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="4" class="pb-0">
              <v-text-field label="Code" :rules="requiredRules" dense outlined v-model="instructor.code" @keyup="toUpperCase($event)" maxlength = "12">
                <template slot="label">{{ $t('code') }}<span style="color:orange"><b>*</b></span></template>
              </v-text-field>
            </v-col>
            <v-col cols="6" class="pb-0">
              <v-select label="Languages Known" :items="Languages" item-text="name" item-value="id" outlined :rules="requiredRules" dense v-model="instructor.languages" multiple>
                <template slot="label">{{ $t('languages') }}<span style="color:orange"><b>*</b></span></template>
              </v-select>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-text-field label="Experience" :hint="$t('experience-hint')" :rules="requiredRules" dense outlined v-model="instructor.year_of_exp" maxlength = "2">
                <template slot="label">{{ $t('experience') }}<span style="color:orange"><b>*</b></span></template>
              </v-text-field>
            </v-col>
            <v-col cols="4" class="pb-0">
              <v-text-field label="License Number" :rules="requiredRules" dense v-model="instructor.license_number" outlined @keyup="toUpperCase($event)">
                <template slot="label">{{ $t('license-number') }}<span style="color:orange"><b>*</b></span></template>
              </v-text-field>
            </v-col>
            <v-col cols="4"  class="pb-0">
              <v-text-field label="Permit Number" :rules="requiredRules" dense outlined v-model="instructor.permit_number" @keyup="toUpperCase($event)">
                <template slot="label">{{ $t('permit-number') }}<span style="color:orange"><b>*</b></span></template>
              </v-text-field>
            </v-col>
            <v-col cols="2" class="pb-0">
              <v-menu
                v-model="dobPicker1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on" dense
                    slot="activator"
                    label="Permit Issued Date"
                    prepend-inner-icon="mdi-calendar-month"
                    :rules="requiredRules"
                    readonly outlined
                    :value="dateFormatted(instructor.permit_issue_date)"
                  >
                    <template slot="label">{{ $t('permit-issue-date') }}<span style="color:orange"><b>*</b></span></template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="instructor.permit_issue_date" @input="dobPicker1 = false; instructor.permit_issue_exp = null"></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="2"  class="pb-0">
              <v-menu
                v-model="dobPicker2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-on="on" dense
                    slot="activator"
                    label="Permit Expiry Date"
                    prepend-inner-icon="mdi-calendar-month"
                    :rules="requiredRules"
                    readonly outlined
                    :value="dateFormatted(instructor.permit_issue_exp)"
                  >
                    <template slot="label">{{ $t('permit-expiry-date') }}<span style="color:orange"><b>*</b></span></template>
                  </v-text-field>
                </template>
                <v-date-picker v-model="instructor.permit_issue_exp" :min="instructor.permit_issue_date" @input="dobPicker2 = false"></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="my-2">
        <v-subheader class="blue accent-4" style="color:white" dark><b>{{ $t('instructor.tab3-header') }}</b></v-subheader>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="6" class="pb-0">
              <v-select :items="Training" :item-text="$i18n.locale=='en'? 'name_en':'name_ar'" item-value="id" :rules="requiredRules" dense v-model="instructor.training_provided" outlined multiple>
                <template slot="label">{{$t('training-provided')}}<span style="color:orange"><b>*</b></span></template>
              </v-select>
            </v-col>
            <v-col cols="3" class="pb-0">
              <v-menu
                ref="menu"
                v-model="timepicker1"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time"
                transition="scale-transition"
                offset-y
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="instructor.start_time" dense
                    label="Start Time"
                    prepend-inner-icon="mdi-clock-time-four-outline"
                    readonly outlined
                    v-bind="attrs" :rules="requiredRules"
                    v-on="on"
                  >
                    <template slot="label">{{$t('start-time')}}<span style="color:orange"><b>*</b></span></template>
                  </v-text-field>
                </template>
                <v-time-picker
                  v-if="timepicker1"
                  v-model="instructor.start_time"
                  @click:minute="$refs.menu.save(time)"
                ></v-time-picker>
              </v-menu>
            </v-col>
            <v-col cols="3" class="pb-0">
              <v-menu
                ref="menu1"
                v-model="timepicker2"
                :close-on-content-click="false"
                :nudge-right="40"
                :return-value.sync="time1"
                transition="scale-transition"
                offset-y 
                max-width="290px"
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="instructor.end_time" dense
                    label="End Time"
                    prepend-inner-icon="mdi-clock-time-four-outline"
                    readonly outlined
                    v-bind="attrs" :rules="requiredRules"
                    v-on="on"
                  >
                    <template slot="label">{{$t('end-time')}}<span style="color:orange"><b>*</b></span></template>
                  </v-text-field>
                </template>
                <v-time-picker
                  v-if="timepicker2"
                  v-model="instructor.end_time"
                  @click:minute="$refs.menu1.save(time1)"
                ></v-time-picker>
              </v-menu>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card class="my-2">
        <v-subheader class="blue accent-4" style="color:white" dark><b>{{ $t('instructor.tab4-header') }}</b></v-subheader>
        <v-divider></v-divider>
        <v-card-text>
          <v-row>
            <v-col cols="6"  class="pb-0">
              <v-file-input v-model="instructor.cv_file" prepend-icon="" prepend-inner-icon="mdi-paperclip" show-size :label="$t('cv')" :rules="imageRules" accept="image/png, image/jpeg, image/bmp" dense outlined></v-file-input>
            </v-col>
            <v-col cols="6"  class="pb-0">
              <v-file-input v-model="instructor.dl_file" prepend-icon="" prepend-inner-icon="mdi-paperclip" show-size :label="$t('licence')" :rules="imageRules" accept="image/png, image/jpeg, image/bmp" dense outlined></v-file-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6"  class="pb-0">
              <v-file-input v-model="instructor.eid_file" prepend-icon="" prepend-inner-icon="mdi-paperclip" show-size :label="$t('emirates')" :rules="imageRules" accept="image/png, image/jpeg, image/bmp" dense outlined></v-file-input>
            </v-col>
            <v-col cols="6"  class="pb-0">
              <v-file-input v-model="instructor.permit_file" prepend-icon="" prepend-inner-icon="mdi-paperclip" show-size :label="$t('permit')" :rules="imageRules" accept="image/png, image/jpeg, image/bmp" dense outlined></v-file-input>
            </v-col>
            <v-col cols="6"  class="pb-0">
              <v-file-input v-model="instructor.signature_file" prepend-icon="" prepend-inner-icon="mdi-paperclip" show-size :label="$t('sign')" :rules="imageRules" accept="image/png, image/jpeg, image/bmp" dense outlined></v-file-input>
            </v-col>
            <v-col cols="6"  class="pb-0">
              <v-file-input v-model="instructor.profile_file" prepend-icon="" prepend-inner-icon="mdi-paperclip" show-size :label="$t('profile')" :rules="imageRules" accept="image/png, image/jpeg, image/bmp" dense outlined></v-file-input>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-form>
    <v-row>
      <v-col>
        <div class="float-right">
          <v-btn  class="mx-1" color="warning" outlined dark @click="reset()">{{$t('clear-btn')}}</v-btn>
          <v-btn  class="mx-1" color="success" outlined dark @click="addInstructor()">{{$t('add-btn')}}</v-btn>
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import moment from 'moment'
import WebService from '@/service/WebService'
export default {
  data () {
    return {
      user_type_id: localStorage.getItem('user_type_id'),
      time:'',
      time1:'',
      dobPicker1:'',
      dobPicker2:'',
      timepicker1:'',
      timepicker2:'',
      search: '',
      instructor:{
        languages: [],
        training_provided: []
      },
      Schools:[],
      Country: [],
      Emirates: [],
      Languages: [],
      Training: [],
      Gender:[
        {name:'Male', id:'1'},
        {name:'Female', id:'2'}
      ],
      // Rules
      whiteSpaceRules : [
        v => /^(?!\s)[a-zA-Z0-9_\s-]*$/.test(v)|| 'Enter Valid Value'
      ],
      imageRules: [
        value => !value || value.size < 204900 || 'File size should be less than 200KB!',
      ],
      requiredRules: [
        v => !!v || 'This field is required',
      ],
      numberRules: [
        v => !!v || 'This field is required.',
        v => /^\d{0,9}(\.\d{1,3})?$/.test(v) || 'Enter Valid Amount',
      ],
      emailRules: [
        v => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
      phoneRules: [
        v => /^([+0-9]{1,2})?[0-9]{9,13}$/.test(v) || 'Number must be valid'
      ],
      errors:{},
      Crums: [
        {
          text: 'Instructors',
          disabled: false,
          to: '/instructor-list',
        },
        {
          text: 'Add New Instructor',
          disabled: true,
          to: 'breadcrumbs_link_2',
        },
      ],
    }
  },
  mounted () {
    this.getAllSchools()
    this.getCountry() 
    this.getEmirates() 
    this.getLanguages() 
    this.getTraining() 
  },
  methods : {
    addInstructor () {
      if(this.$refs.form.validate()){
        this.$refs.commonManage.open(1, true)
        if(this.user_type_id==2)
          this.instructor.school_id = localStorage.getItem('user_id')
        let formData = new FormData()
        formData.append("school_id",this.instructor.school_id)
        formData.append("name",this.instructor.name)
        formData.append("email",this.instructor.email)
        formData.append("contact_number",this.instructor.contact_number)
        formData.append("gender",this.instructor.gender)
        formData.append("country_id",this.instructor.country_id)
        formData.append("emirate_id",this.instructor.emirate_id)
        formData.append("address_line_1",this.instructor.address_line_1)
        if(this.instructor.address_line_2)
          formData.append("address_line_2",this.instructor.address_line_2)
        if(this.instructor.po_box)
          formData.append("po_box",this.instructor.po_box)
        formData.append("nationality_id",this.instructor.nationality_id)
        formData.append("eid",this.instructor.eid)
        formData.append("code",this.instructor.code)
        for (let i = 0; i < this.instructor.languages.length; i++) {
          formData.append("languages[" + i + "]",this.instructor.languages[i])
        }
        for (let i = 0; i < this.instructor.training_provided.length; i++) {
          formData.append("training_provided[" + i + "]",this.instructor.training_provided[i])
        }
        formData.append("year_of_exp",this.instructor.year_of_exp)
        formData.append("license_number",this.instructor.license_number)
        formData.append("permit_number",this.instructor.permit_number)
        formData.append("permit_issue_date",this.instructor.permit_issue_date)
        formData.append("permit_issue_exp",this.instructor.permit_issue_exp)
        formData.append("start_time",this.instructor.start_time)
        formData.append("end_time",this.instructor.end_time)
        if(this.instructor.cv_file)
          formData.append("cv_file",this.instructor.cv_file)
        if(this.instructor.dl_file)
          formData.append("dl_file",this.instructor.dl_file)
        if(this.instructor.eid_file)  
          formData.append("eid_file",this.instructor.eid_file)
        if(this.instructor.permit_file)
          formData.append("permit_file",this.instructor.permit_file)
        if(this.instructor.signature_file)
          formData.append("signature_file",this.instructor.signature_file)
        if(this.instructor.profile_file)
          formData.append("profile_file",this.instructor.profile_file)
        WebService.postCall('instructors', formData).then((response) => {
          if(response.data.response.status == 200){
            this.$refs.commonManage.open(1, false)
            let data = {}
            data.message = response.data.response.message
            data.colour = "success"
            this.$refs.commonManage.open(3, data)
            this.$router.push('/instructor-list')
          } else if(response.data.response.status == 400){
            this.errors = response.data.response.errors
            this.$refs.commonManage.open(1, false)
          }
        });
      }
    },
    getAllSchools () {
      this.$refs.commonManage.open(1, true)
      WebService.getCall('school').then((response) => {
        this.Schools = response.data.data.data
        this.$refs.commonManage.open(1, false)
      });
    },
    getCountry() {
      this.$refs.commonManage.open(1, true)
      WebService.getCall('countries').then((response) => {
        this.Country = response.data
        this.$refs.commonManage.open(1, false)
      });
    },
    getEmirates () {
      this.$refs.commonManage.open(1, true)
      WebService.getCall('emirates').then((response) => {
        this.Emirates = response.data
        this.$refs.commonManage.open(1, false)
      });
    },
    getLanguages () {
      this.$refs.commonManage.open(1, true)
      WebService.getCall('languages').then((response) => {
        this.Languages = response.data
        this.$refs.commonManage.open(1, false)
      });
    },
    getTraining() {
      this.$refs.commonManage.open(1, true)
      WebService.getCall('training-list').then((response) => {
        this.Training = response.data
        this.$refs.commonManage.open(1, false)
      });
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    },
    dateFormatted (params) {
      return params ? moment(params).format('D-M-Y') : ''
    },
    toUpperCase (e) {
      e.target.value = e.target.value.toUpperCase()
    }
  },
  beforeRouteEnter (to, from, next) {
    if (localStorage.getItem('loggedIn') === 'true') {
      next()
    } else {
      next('/')
    }
  }
}
</script>